import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComingSoon from "../components/ComingSoon";

function ECMList() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ComingSoon
        title="UDS Enterprise Content Management"
        description="Unser Enterprise Content Management System wird aktuell nur ausgewählten Testkunden zur Verfügung gestellt. Das ECM-System ermöglicht die zentrale Verwaltung und Organisation aller Unternehmensdokumente, optimiert Workflows und erhöht die Effizienz Ihrer Dokumentenprozesse. Bleiben Sie gespannt auf die öffentliche Verfügbarkeit!"
        productUrl="https://www.unitas.cloud/produkte/ecm"
      />
      <Footer />
    </DashboardLayout>
  );
}

export default ECMList;
